import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import M from "materialize-css/dist/js/materialize.min.js";
import Modal from "../../../helper/modal";
import TableHeader from "../../../helper/tableHeader";
import $ from "jquery";
import { payNEO, payBTC, payETH, payLSK, payWAV, payNRG, payEMB, payDAI, payUSDT} from "../../../../actions/transfers/set";
import { colors, tokenDictionary, shortenHash } from "../../../../config";
import "./matched.css";
import TransferDetails from "../../../helper/transferDetails";
import { getNEOFee, getBTCFee, getETHFee, getLSKFee, getWAVFee, getNRGFee, getEMBFee, getDAIFee, getUSDTFee} from "../../../../actions/transfers/fees";
import { take } from "ramda";
import InfiniteScroll from 'react-infinite-scroll-component';
import md5 from 'md5';
const { green, red } = colors;

class MatchedOrders extends Component {
  constructor() {
    super();
    this.state = {
      showChecking:true,
      from: 0,
      amount: 0,
      to: 0,
      fee: 0,
      chain: "",
      txHash: null,
      txOutputIndex: 0,
      sending: {},
      hasMore:false,nextIndex:1,orders:[]
    };
  }
  componentDidUpdate(prevProps){
    let oldmd5 = md5(JSON.stringify(prevProps.orders));
    let newmd5 = md5(JSON.stringify(this.props.orders));
    // console.log(`${oldmd5} ${newmd5}`)
    if(prevProps.orders.length === 0 && this.props.orders.length > 0 || oldmd5 != newmd5){
      this.setState({orders:take(20,this.props.orders),hasMore:true})
    }
    else if(this.props.orders.length != prevProps.orders.length){
      this.setState({hasMore:true,orders:take(this.state.nextIndex*20,this.props.orders)})
    }
  }
  componentDidMount(){
    this.setState({orders:take(20,this.props.orders),hasMore:true})
  }
  fetchMoreData(){
    let { nextIndex, orders} = this.state;
    nextIndex++;
    this.setState({orders:take(20*nextIndex,this.props.orders),nextIndex})
    if(20*nextIndex >= this.props.orders.length){
      this.setState({hasMore:false,nextIndex})
    }
    return;
  }
  renderModal() {
    let component = (
      <TransferDetails
        settle={true}
        amount={this.state.amount}
        to={this.state.to}
        from={this.state.from}
        fee={this.props.fee}
        chain={this.state.chain}
      />
    );
    return (
      <Modal
        id="modalSettlement"
        title={`Settle ${this.state.chain.toUpperCase()} Trade`}
        noClose={true}
        classes="modal modalOrders black-text"
        chain={this.state.chain}
        component={component}
        isOrder={false}
        style={{maxWidth:'500px'}}
        decryption={true}
        buttonText={"Confirm"}
        passwordId="settlepass"
        buttonAction={this.submitOperation.bind(this)}
      />
    );
  }
  submitOperation() {
    let password = $("#settlepass").val();
    var instance = M.Modal.getInstance(document.querySelectorAll("#modalSettlement")[0]);
    this.setState({showChecking:true})

    setTimeout(()=>{
      if(this.state.showChecking) {
        M.toast({html: 'Submitting Transaction',classes:"grey",displayLength:3000});
        if (instance) instance.close();
      }
    },50);

    let { amount, to, chain, from, txHash, txOutputIndex } = this.state;
    this.props[`pay${chain.toUpperCase()}`]({ password, amount, to, address: from, txHash, txOutputIndex },(err, tx) => {
      if (!err) {
        $("#settlepass")[0].value = "";
        M.toast({ html: "Transaction Submitted!", classes: "green", displayLength: 2000,});
        let sending = this.state.sending;
        sending[`${txHash}.${txOutputIndex}.${chain.toUpperCase()}`] = true;
        this.setState({ sending,showChecking:false });
        if(instance) instance.close();
      } else {
        M.toast({ html: err, classes: "red", displayLength: 2000 });
        if (instance) instance.open();
        this.setState({showChecking:false})
      }
    });
  }
  handleFormSubmit({ from, to, amount, chain, txHash, txOutputIndex }) {
    this.setState({ from, to, amount, chain, txHash, txOutputIndex });
    if (chain.toLowerCase() === "btc" || chain.toLowerCase() == "nrg") {
      this.props[`get${chain.toUpperCase()}Fee`](amount, from);
    } else {
      this.props[`get${chain.toUpperCase()}Fee`](amount);
    }
    var instance = M.Modal.getInstance(
      document.querySelectorAll("#modalSettlement")[0]
    );
    if (instance) instance.open();
    setTimeout(() => {
      if ($("#settlepass")) $("#settlepass").focus();
    }, 100);
  }
  renderMempool(){
    let elems = [];
    for(let order of this.props.takers){
      if(order.maker.mine) {
        elems.push(
          <tr style={{color:'grey'}} className="matched" onMouseOver={()=>{console.log({txHash:order.hash, txOutputIndex:order.index})}}>
            <td className="matchedSend">
              {`${order.sendsAmount}`} {order.maker.sendsFromChain.toUpperCase().replace('NRG','OVERLINE')} to {`${shortenHash(order.receivesToAddress, 6)}`}
            </td>
            <td className="matchedReceive">
              {`${order.receivesAmount}`} {order.maker.receivesToChain.toUpperCase().replace('NRG','OVERLINE')} to {`${shortenHash(order.maker.receivesToAddress, 6)}`}
            </td>
            <td className="matchedCollateral">
              {order.value} OVERLINE
            </td>
            <td className="matchedDeadline"> {order.maker.settleLeft} </td>
            <td className="matchedStatus" style={{ lineHeight: "25px", fontSize: "10px" }}> In Mempool</td>
          </tr>
        )
      }
      if(order.mine){
        elems.push(
          <tr style={{color:'grey'}} className="matched" onMouseOver={()=>{console.log({txHash:order.hash, txOutputIndex:order.index})}}>
            <td className="matchedSend">
              {`${order.receivesAmount}`} {order.maker.receivesToChain.toUpperCase().replace('NRG','OVERLINE')} to {`${shortenHash(order.maker.receivesToAddress, 6)}`}
            </td>
            <td className="matchedReceive">
              {`${order.sendsAmount}`} {order.maker.sendsFromChain.toUpperCase().replace('NRG','OVERLINE')} to {`${shortenHash(order.receivesToAddress, 6)}`}
            </td>
            <td className="matchedCollateral">
              {order.value} OVERLINE
            </td>
            <td className="matchedDeadline"> {order.maker.settleLeft} </td>
            <td className="matchedStatus" style={{ lineHeight: "25px", fontSize: "10px" }}> In Mempool</td>
          </tr>
        )
      }
    }
    return elems;
  }
  renderItems(orders) {
    let ordersToFulfill = {};
    return orders.map(
      (
        {
          address,
          sendsToAddress,
          receivesFromAddress,
          sendsFromChain,
          receivesToChain,
          sendsAmount,
          receivesAmount,
          sendsFromAddress,
          receivesToAddress,
          yourStatus,
          theirStatus,
          collateral,
          deadline,
          txHash,
          txOutputIndex,
        },
        i
      ) => {
        let them = (
          <a style={{ color: theirStatus ? green : red }}>
            {theirStatus ? `Received ${receivesToChain.toUpperCase()}` : `Waiting for ${receivesToChain.toUpperCase()}`}{" "}
          </a>
        );

        let sending = null;

        let sendClick = this.handleFormSubmit.bind(this, {from: sendsFromAddress, to: sendsToAddress, amount: sendsAmount, chain: sendsFromChain, txHash, txOutputIndex});

        //user has the proper wallet
        let properWallet = this.props.wallet[sendsFromChain.toLowerCase()] && this.props.wallet[sendsFromChain.toLowerCase()][sendsFromAddress];
        // console.log({yourStatus,txHash})
        if (!yourStatus && this.state.sending[`${txHash}.${txOutputIndex}.${sendsFromChain.toUpperCase()}`]) sending = "Sending";

        let you = <button onClick={sendClick} style= {{padding:0}} className="btn clickablesYellow"> Send {sendsFromChain.toUpperCase()}
            <i className='material-icons' style={{float:'right',paddingRight:'5px',fontSize:'10px'}}>send</i>
        </button>;

        if (yourStatus === true) you = <a style={{ color: green }}> {`Sent ${sendsFromChain.toUpperCase()}`}{" "} </a>;
        if (sending === "Sending" || yourStatus === "Sending") you = (<a style={{ color: "grey" }}> {`Sending ${sendsFromChain.toUpperCase()}`}{" "} </a>);
        if (!properWallet) you = (<Link to="/" style={{ color: "white", cursor: "pointer" }}> <u> Upload Wallet</u>{" "}</Link>);

        //Analyze Txhash and output index for those txs that are being sent
        if (ordersToFulfill[`${sendsFromChain}${sendsFromAddress}${sendsToAddress}${sendsAmount}`] && !yourStatus) {
          you = <a style={{ color: "grey" }}>Wait to Send </a>;
        }

        if (sendsFromChain === "NRG") you = null;
        if (receivesToChain === "NRG") them = null;
        if (yourStatus == false) ordersToFulfill[`${sendsFromChain}${sendsFromAddress}${sendsToAddress}${sendsAmount}`] = `${txHash}${txOutputIndex}`;

        return (
          <tr key={i} className="matched" onMouseOver={()=>{console.log({txHash, txOutputIndex})}}>
            <td className="matchedSend">
              {`${sendsAmount}`} {sendsFromChain} to {`${shortenHash(sendsToAddress, 6)}`}
            </td>
            <td className="matchedReceive">
              {`${receivesAmount}`} {receivesToChain} to {`${shortenHash(receivesToAddress, 6)}`}
            </td>
            <td className="matchedCollateral">
              {collateral} OVERLINE
            </td>
            <td className="matchedDeadline"> {deadline} </td>
            <td className="matchedStatus" style={{ lineHeight: "25px", fontSize: "10px" }}> {you} {them}</td>
          </tr>
        );
      }
    );
  }
  render() {
    let items = ["Send", "Receive", "Collateral", "Settlement", "Status"];
    let classes = ["matchedSend", "matchedReceive", "matchedCollateral", "matchedDeadline", "matchedStatus"];
    let noOrders = this.props.orders.length == 0 && this.props.takers.length == 0;
    let {orders} = this.state;

    return (
      <div className="col m6" style={{ paddingLeft: "0.375rem"}}>
        <h6 style={{ marginTop: "10px", marginLeft: "2px", color: "white" }}>
          <span style={{ cursor: "pointer", paddingRight: "10px", color: "white" }}>
            {`Matched Orders (${this.props.orders.length + this.props.takerAmount})`}
          </span>
        </h6>

        <div className="col s12 section">
          <TableHeader items={items} classes={classes} />
          <div className="col s12 myOrders">
            <InfiniteScroll
            className="infiniteScrollComponent"
                    height={200}
                    dataLength={orders.length}
                    next={this.fetchMoreData.bind(this)}
                    hasMore={this.state.hasMore}
                    loader={<p>Loading...</p>}
                >
                <table className="white-text order-book striped" style={{tableLayout:"fixed",fontSize:"0.9em",height:'30px',lineHeight:'30px'}}>
                  <tbody>
              {this.renderMempool()}
              {this.renderItems(orders)}
              </tbody>
              </table>
              {noOrders ?
                <p style={{color:'grey',marginLeft:'5px',marginTop:0,fontSize:'10px'}}> No Orders</p>
                : null
              }
            </InfiniteScroll>
            {this.renderModal()}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  let takers = state.mempool.takers.filter(({mine,maker})=>{return mine === true || maker.mine === true});
  let takerAmount = takers.reduce((all,{maker,mine})=> {
    let count = mine ? 1 : 0;
    if(maker.mine) count++;
    return count;
  },0)
  return {
    takerAmount,
    takers,
    wallet: state.passport.wallet,
    fee: state.passport.fee,
    orders: state.orderbook.my_matched_orders,
  };
}

export default connect(mapStateToProps, {
  getNEOFee,
  getBTCFee,
  getETHFee,
  getLSKFee,
  getWAVFee,
  getNRGFee,
  getEMBFee,
  getDAIFee,
  getUSDTFee,
  payNEO,
  payBTC,
  payETH,
  payLSK,
  payWAV,
  payNRG,
  payEMB,
  payDAI,
  payUSDT,
})(MatchedOrders);
